import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { campaignsEndpoints as endpoints } from '@/api/endpoints';
import { callGet } from '@/api/fetcher';
import { getPermissions } from '@/redux/permissions/selectors';
import { CampaignSubscriberWithJourney } from '@/shared/types/campaigns';
import { actions } from '@/shared/types/permissions';
import { RootState } from '@/shared/types/state';

const DECIDING_POLL_MS = 2000;

const getCampaignSubscriber = async (
  campaignId: string,
  subscriberId: string
): Promise<CampaignSubscriberWithJourney> =>
  callGet(endpoints.campaignSubscriber(campaignId, subscriberId));

export const useCampaignSubscriber = (campaignId?: string, subscriberId?: string) => {
  const canRead = useSelector((state: RootState) =>
    getPermissions(state, 'campaigns', actions.READ)
  );

  const {
    data: subscriber,
    isLoading,
    status,
  } = useQuery({
    queryKey: [endpoints.campaignSubscriber(campaignId, subscriberId)],
    queryFn: () => getCampaignSubscriber(campaignId!, subscriberId!),
    enabled: !!campaignId && !!subscriberId && canRead,
    refetchInterval: ({ state }) =>
      state.data?.next_action?.state === 'deciding' ? DECIDING_POLL_MS : false,
  });

  return { subscriber, isLoading, status };
};
